import { useModules } from '@/hooks/use-modules';
import { usePermissions } from '@/hooks/use-permissions';
import { useLocationStore } from '@/stores/location-store';

/**
 * Whether the super admin has left Reports switched on for the selected
 * location (tenant_modules 'reporting').
 *
 * Reports is on by default, so only an explicit `false` from the API turns it
 * off. While the module list is still loading — or for a tenant kind that isn't
 * offered the module at all — this stays true, so the page and its links never
 * flicker away for the vast majority of businesses that keep Reports.
 */
export function useReportsEnabled(): boolean {
  const { selectedLocationId } = useLocationStore();
  const { data } = useModules(selectedLocationId);
  const row = data?.data.find((m) => m.moduleName === 'reporting');
  return row?.superAdminEnabled !== false;
}

/**
 * Whether the signed-in user can actually open Reports: the module switched on
 * and any Reports permission held (same rule as the /reports route in app.tsx).
 * Use it to decide whether to offer a link into Reports at all.
 */
export function useCanOpenReports(): boolean {
  const enabled = useReportsEnabled();
  const permissions = usePermissions();
  return enabled && permissions.canOpen('reports');
}
